import { render } from "./PhotoUpdate.vue?vue&type=template&id=aa336346&scoped=true"
import script from "./PhotoUpdate.vue?vue&type=script&lang=js"
export * from "./PhotoUpdate.vue?vue&type=script&lang=js"

import "./PhotoUpdate.vue?vue&type=style&index=0&id=aa336346&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa336346"]])

export default __exports__